class ConsentFormHubSpot extends HTMLElement {
  constructor() {
    super();
    this.maxRetries = 12;
    this.attempts = 0;
  }

  connectedCallback() {
    this.portalId = this.dataset.portalId;
    this.formId = this.dataset.formId;
    this.region = this.dataset.region || 'na1';
    this.target = this.querySelector('[data-hs-target]');

    if (!this.target || !this.portalId || !this.formId) {
      console.warn('[consent-form] Falta target, portalId o formId.');
      return;
    }

    this.load();
  }

  createForm() {
    try {
      window.hbspt.forms.create({
        region: this.region,
        portalId: this.portalId,
        formId: this.formId,
        target: '#' + this.target.id
      });
    } catch (error) {
      console.error('[consent-form] Error al crear formulario:', error);
    }
  }

  load() {
    if (typeof window.hbspt !== 'undefined' && window.hbspt.forms) {
      this.createForm();
      return;
    }

    if (!document.getElementById('cf-hs-shell')) {
      const script = document.createElement('script');
      script.id = 'cf-hs-shell';
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.defer = true;
      document.head.appendChild(script);
    }

    const poll = setInterval(() => {
      this.attempts++;
      if (typeof window.hbspt !== 'undefined' && window.hbspt.forms) {
        clearInterval(poll);
        this.createForm();
      } else if (this.attempts >= this.maxRetries) {
        clearInterval(poll);
        this.target.innerHTML =
          '<p class="cf-consent__fallback">El formulario no está disponible en este momento. Por favor, <a href="mailto:hola@adrianagallardo.com">contáctanos directamente</a>.</p>';
      }
    }, 600);
  }
}

customElements.define('consent-form-hubspot', ConsentFormHubSpot);
